import script from "./employee-employment-status-confirm-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./employee-employment-status-confirm-modal.vue?vue&type=script&setup=true&lang=js"

import "./employee-employment-status-confirm-modal.vue?vue&type=style&index=0&id=8b534448&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b534448"]])

export default __exports__